import russianMessages from "ra-language-russian";

const newRussianMessages = {
  ...russianMessages,
  locales: {
    en: "Английский",
    ru: "Русский"
  },
  pages: {
    login: {
      fields: {
        email: "Email",
        password: "Пароль",
      }
    },
    settings: {
      label: "Настройки",
      appearance: {
        label: "Внешний вид",
        theme: "Тема",
        options: {
          theme: {
            light: "Светлая",
            dark: "Тёмная",
            auto: "Авто"
          }
        }
      },
      localization: {
        label: "Локализация",
        language: "Язык"
      },
      cache: {
        label: "Кеш",
        download: "Скачать"
      },
      authorization: {
        label: "Авторизация"
      }
    }
  },
  actions: {
    filter: "Фильтр",
    show: "Показать",
  },
  notifications: {
    bulk_delete_title: "Вы уверены, что хотите удалить эту запись?",
    bulk_delete_content: "Это действие невозможно отменить."
  },
  resources: {
    users: {
      name: "Пользователь |||| Пользователи",
      fields: {
        username: "Имя пользователя",
        email: "Email",
        password: "Пароль",
        active: "Активен",
        permissions: "Права",
        status: "Статус",
        authType: "Тип аутентификации",
        emailIsConfirmed: "Email подтвержден",
        goldCapss: "Gold caps",
        sparks: "Sparks",
      },
      options: {
        active: {
          ACTIVE: "Активен",
          BLOCKED: "Заблокирован"
        },
        permissions: {
          PLAY: "Игрок",
          CREATE_USER: "Создать пользователя",
          EDIT_USER: "Редактировать пользователя",
          DELETE_USER: "Удалить пользователя",
          CREATE_SEASON: "Создать сезон",
          EDIT_SEASON: "Редактировать сезон",
          DELETE_SEASON: "Удалит сезон"
        },
        authType: {
          EMAIL: "Электронная почта",
        },
      },
    },
    seasons: {
      name: "Сезон |||| Сезоны",
      fields: {
        startDate: "От",
      },
    },
    collections: {
      name: "Коллекция |||| Коллекции",
      fields: {
        name: "Имя",
        season: "Сезон от",
        packAssetBundle: "Asset Bundle для упаковки",
      },
    },
    caps: {
      name: "Фишка |||| Фишки",
      fields: {
        type: "Тип",
        preview: "Превью",
        assetBundle: "Asset Bundle",
      },
      options: {
        type: {
          COMMON: "Обычная",
          RARE: "Редкая",
          LEGENDARY: "Легендарная"
        },
      },
    },
  },
};

export default newRussianMessages;
